import {
    type ApiMessageAction,
    EnumMessageAction,
    useActionMessage,
    useToasts,
} from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import { useClientNavigate } from '../../Routing/useClientNavigate';
import { useLatestContainerRentOrderIds } from './useLatestContainerRentOrderIds';

// @ai-generated 2026-10-21T10:12:41+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function isActionMessageToLoadContainerRentOrders(message: ApiMessageAction) {
    return message.action === EnumMessageAction.LoadRelatedData && message.resource_type === 'container_rent';
}

/** The ids of the orders a rent booking created. */
// @ai-generated 2026-10-21T10:12:41+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function orderIdsOfContainerRentMessage(message: ApiMessageAction): string[] {
    const [option] = message.options;

    return option ? (JSON.parse(option.value) as string[]) : [];
}

let bookingNotifications: string[] = [];

// @ai-generated 2026-10-21T10:12:41+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function registerContainerRentNotification(id: string) {
    bookingNotifications.push(id);
}

// @ai-generated 2026-10-21T10:12:41+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function useNotifyBookedContainerRent() {
    const navigate = useClientNavigate();
    const { storeLatestOrderIds } = useLatestContainerRentOrderIds();
    const { remove } = useToasts();

    const storeOrderIds = useCallback(
        (message: ApiMessageAction) => {
            const orderIds = orderIdsOfContainerRentMessage(message);
            if (orderIds.length > 0) {
                storeLatestOrderIds(orderIds);
            }

            const notificationIds = bookingNotifications;
            bookingNotifications = [];
            notificationIds.forEach(remove);
        },
        [storeLatestOrderIds, remove],
    );

    const navigateToLatestView = useCallback(() => {
        navigate('/container_rent?mode=latest');
    }, [navigate]);

    useActionMessage({
        canHandle: isActionMessageToLoadContainerRentOrders,
        handleMessage: storeOrderIds,
        handleOption: navigateToLatestView,
    });
}
